(() => {
  if (window.blincSocialDialogReady) return;
  window.blincSocialDialogReady = true;
  let source = [], index = 0, opener;
  const show = (dialog, position) => {
    index = (position + source.length) % source.length;
    const link = source[index], image = link.querySelector('img');
    const photo = dialog.querySelector('[data-social-photo]');
    photo.src = image.currentSrc || image.src;
    photo.alt = image.alt;
    dialog.querySelector('[data-social-caption]').textContent = image.alt;
    dialog.querySelector('[data-social-original]').href = link.href;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-blinc-social-gallery] a');
    if (link && link.querySelector('img') && /instagram\.com\/p\//.test(link.href)) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const dialog = document.querySelector('[data-blinc-social-dialog]');
      if (!dialog) return;
      event.preventDefault();
      opener = link;
      source = [...link.closest('[data-blinc-social-gallery]').querySelectorAll('a')].filter(item => item.querySelector('img'));
      show(dialog, source.indexOf(link));
      if (!dialog.open) {
        const origin = { left: window.scrollX, top: window.scrollY, behavior: 'instant' };
        const restorePosition = () => window.scrollTo(origin);
        dialog.addEventListener('close', () => {
          if (opener?.isConnected) opener.focus({ preventScroll: true });
          restorePosition();
        }, { once: true });
        dialog.showModal();
        dialog.querySelector('[data-social-close]').focus({ preventScroll: true });
        restorePosition();
      }
      return;
    }
    const dialog = event.target.closest('[data-blinc-social-dialog]');
    if (!dialog) return;
    if (event.target.closest('[data-social-close]')) dialog.close();
    const step = event.target.closest('[data-social-step]');
    if (step) show(dialog, index + Number(step.dataset.socialStep));
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('keydown', event => {
    const dialog = document.querySelector('[data-blinc-social-dialog][open]');
    if (!dialog || event.target.matches('input,textarea,select')) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); show(dialog, index + (event.key === 'ArrowLeft' ? -1 : 1));
    }
  });
})();
